<template>
    <form-container valid-actions="['leiheEdit']"
                    action="leiheEidit"
                    header-text="Leihpass-Nr. erfassen"
                    :header-sub-text="spieler?spieler.vorname+' '+spieler.nachname:''" text="Leihpass-Nr. erfassen"
                    @save="save">
        <v-card-text v-if="spieler" class="pt-0 px-7">
            <v-text-field v-model="passNr" label="Leihspieler-Pass"
                            :rules="[rules.required]" >
            </v-text-field>
        </v-card-text>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {Spieler} from "../../services/data/spieler/spieler";
    import {FormRules} from "../../services/formRules";
    import SPIELER_CHANGE_HANDLER from "../../services/data/spieler/spielerChangeHandler";

    export default {
        components: {FormContainer},
        name: "paesse-leihe-edit",
        props: ['itemSelected'],
        data: () => ({
            spieler: null,
            passNr: '',
            rules: null,
        }),
        created(){
            if ( this.itemSelected ) {
                this.setSpieler();
            }
            this.rules = new FormRules();
        },
        methods: {
            setSpieler(){
                this.spieler = new Spieler();
                this.spieler.setFromDataObject(this.itemSelected);
                if ( this.itemSelected.local.leihPassNr !== 'beantragt' ) {
                    this.passNr = this.itemSelected.local.leihPassNr
                }
            },
            async save(){
                this.$store.state.local.loader = true;
                this.spieler.local.documentUpdates = SPIELER_CHANGE_HANDLER.getDataObjectForLeihePassNr(
                                                                this.spieler, this.passNr);
                await this.spieler.updateWithTransaction('spieler_edit', false);
                window.history.back();
                this.$store.state.local.loader = false;
            }
        },
        watch: {
            itemSelected(){
                this.setSpieler()
            }
        }
    }
</script>

<style scoped>

</style>